import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { useField, ErrorMessage } from "formik";

// App
import { CheckboxListProps, Options } from "../../../types";
import { Row } from "react-bootstrap";
import { GIFT_INVESTMENT_OPTION_OTHER_ID } from "./constants";

const GiftOptions: React.FC<CheckboxListProps> = ({
    columns: col = 2,
    name,
    options,
    label,
    isRequired,
    onChange,
    labelStyle
}) => {
    const [field, meta] = useField(name);
    const { onChange: fieldOnChange, ...fieldProps } = field;

    const handleCheckboxChange = (optionId: string) => {
        const updatedOptions = field?.value?.includes(optionId)
            ? field?.value?.filter((id: string) => id !== optionId)
            : [...field.value, optionId];
        // Formik default handleChange
        fieldOnChange({ target: { name: field.name, value: updatedOptions } });
        if (onChange) {
            onChange(updatedOptions);
        }
    };

    const checkboxesInColumns = options?.reduce(
        (columns: Options[][], checkbox, index) => {
            const columnIndex = index % col; // Adjust the number of columns as needed
            columns[columnIndex] = columns[columnIndex] || [];
            columns[columnIndex].push(checkbox);
            return columns;
        },
        []
    );
    const tileMaxWidth = 200;
    const tileHeight = 150;
    
    const OutlineCheckedInput = (column: any) => {
        const disableShowTooltip = field?.value?.includes(GIFT_INVESTMENT_OPTION_OTHER_ID)&&(column?.value!==GIFT_INVESTMENT_OPTION_OTHER_ID);
        return (
            <>
                <span
                    data-toggle="tooltip"
                    title={
                        disableShowTooltip
                        ? "Please unselect Other to toggle other Invest"
                        : ""
                    }
                >
                    <FormGroup check key={column.value} className="border p-4 mb-3" style={{ backgroundColor: "#E6E7E9", borderRadius: "5px", height: tileHeight }}>
                        <Label style={{ width: "100%", textAlign: "center" }}>
                            <Input
                                type="checkbox"
                                {...fieldProps}
                                value={column?.value}
                                id={`${name}-${column?.value}`}
                                name={name}
                                disabled={disableShowTooltip}
                                checked={field?.value?.includes(column?.value)}
                                onChange={() => handleCheckboxChange(column?.value)}
                                style={{ float: "none", marginLeft: "unset", fontSize: "2.25rem" }}
                            />
                            <div style={{ marginTop: "12px" }}>
                                <strong>{column?.label}</strong>
                            </div>
                        </Label>
                    </FormGroup>
                </span>
            </>
        );
    }

    return (
        <FormGroup row tag="fieldset" className="mb-3">
            <Label style={{ ...labelStyle }}>
                {label}
                {isRequired && " *"}
            </Label>
            <div className="container-fluid">
                <Row className="justify-content-center justify-content-lg-start">
                    {checkboxesInColumns?.map((column, columnIndex) => (
                        <Col key={columnIndex} xs={12} sm={6} md={6} lg={6} xl={6} style={{ maxWidth: tileMaxWidth }}>
                            {column?.map((column) => (
                                OutlineCheckedInput(column)
                            ))}
                        </Col>
                    ))}
                </Row>
            </div>

            {meta?.error && (
                <ErrorMessage
                    render={(msg) => (
                        <div className="invalid-feedback" style={{ display: "block" }}>
                            {msg}
                        </div>
                    )}
                    name={name}
                />
            )}
        </FormGroup>
    );
};

export default GiftOptions;
